import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  InputAdornment,
  Typography,
  Grid,
  capitalize,
  Box,
  Paper,
  Stack,
  Avatar,
} from "@mui/material";
import {
  AccountBalance as AccountBalanceIcon,
  TrendingUp as TrendingUpIcon,
  Info as InfoIcon,
} from "@mui/icons-material";
import { formatIdentification, formatNumberWithCommas } from "../../../../utils/generalFunctions";
import Selector from "../../../../components/Selector";
import { fetchClientes, fetchMonedas, fetchProductosFinancieros } from "../../../../utils/generalsFetch";
import { Autocomplete } from "@mui/material";
import MetodoDePagoDialog from "../../centro_cobros/components/metododepagodialog";
import AlertMessageDialog from "../../../../components/Dialogs/alertMessageDialog";


const CobrarInicialMainDialog = ({open, onClose, onConfirm }) => {
  const [monto, setMonto] = useState("");
  const [moneda, setMoneda] = useState("RD$");
  const [productoSelected, setProductoSelected] = useState(null);
  const [camposInventario, setCamposInventario] = useState([]);
  const [financialProductSelected, setFinancialProductSelected] = useState(null);
  const [productosFinancieros, setProductosFinancieros] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clienteSelected, setClienteSelected] = useState(null);
  const [clienteInputValue, setClienteInputValue] = useState("");   
  const [nombreCliente, setNombreCliente] = useState("");
  const [productos, setProductos] = useState([]);
  const [descripcion, setDescripcion] = useState("");
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');

  const showErrorAlert = (message) => {
    setAlertMessage(message);
    setAlertSeverity('error');
    setOpenAlert(true);
  };

  const showSuccessAlert = (message) => {
    setAlertMessage(message);
    setAlertSeverity('success');
    setOpenAlert(true);
  };

  useEffect(() => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setMoneda(data.find((moneda) => moneda.value == "1"));
    }).catch((error) => {
      showErrorAlert(`Error al cargar monedas: ${error.error || error.message || 'Error desconocido'}`);
      console.log(error);
    });
    fetchProductosFinancieros({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProductosFinancieros(data);
    }).catch((error) => {
      showErrorAlert(`Error al cargar productos financieros: ${error.error || error.message || 'Error desconocido'}`);
      console.log(error);
    });
    fetchClientes({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setClientes(data);
    }).catch((error) => {
      showErrorAlert(`Error al cargar clientes: ${error.error || error.message || 'Error desconocido'}`);
      console.log(error);
    });

  }, []);

  const handleClienteChange = (val) => {
    if(val){
      setNombreCliente(JSON.parse(val.campos)?.["1"]);
      setClienteInputValue(val.identificacion);
    }
    else{
      setNombreCliente("");
      setClienteInputValue("");
    }
    setClienteSelected(val);
    
  };

  const handleClienteInputChange = (event, newInputValue,reason) => {
    if (reason === 'input') {
      const formattedValue = formatIdentification(newInputValue);
      setClienteInputValue(formattedValue); // Esto mantiene formateado el input
      handleClienteSearch(formattedValue);
    } else if (reason === 'clear') {
      setClienteInputValue('');
      handleClienteSearch('');
    }
  }

  const handleClienteSearch = (val) => {
    var cliente = clientes.find(cliente => cliente.identificacion === val);
    if(cliente) {
      setClienteSelected(cliente);
      setNombreCliente(JSON.parse(cliente.campos)?.["1"]);
    } else {
      setClienteSelected(null);
      setNombreCliente("");
      setClienteInputValue("");
    }
  }

  const handleConfirm = async() => {
    if (!monto || parseFloat(monto) <= 0) return; // Validación simple
    
    // Show payment method dialog instead of directly making API call
    setShowPaymentDialog(true);
  };

  const handlePaymentConfirm = async (paymentMethodData) => {
    alert(JSON.stringify(paymentMethodData));
    setPaymentData(paymentMethodData);
    
    let url = `${process.env.REACT_APP_SERVER_URL}/api/iniciales`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          monto: monto,
          identificacion: clienteInputValue,
          nombre: nombreCliente,
          id_producto: productoSelected["id"],
          descripcion: descripcion,
          id_sucursal: localStorage.getItem('id_sucursal'),
          created_by: localStorage.getItem('id'),
          idcompany: localStorage.getItem('idcompany'),
          metodo_pago:paymentMethodData.payments.map(payment => ({
            method: payment.method,
            amount: payment.amount,
            reference: payment.reference
          }))
        })
      });
      if (!response.ok) {
        const error = await response.json();
        console.log(error);
        showErrorAlert(`Error al procesar el cobro inicial: ${error.error || error.message || 'Error desconocido'}`);
        return;
      }
      var data = await response.json();
      showSuccessAlert('Cobro inicial procesado exitosamente');
      onConfirm(data);
      handleClose();
    }
    catch (error) {
      console.log(error);
      showErrorAlert(`Error de conexión al procesar el cobro inicial: ${error.message || 'Error desconocido'}`);
    }
  };

  const handlePaymentDialogClose = () => {
    setShowPaymentDialog(false);
  };

  const handleClose = () => {
    setMonto("");
    setDescripcion("");
    setProductoSelected(null);
    setFinancialProductSelected(null);
    setCamposInventario([]);
    setNombreCliente("");
    setClienteInputValue("");
    setProductos([]);
    
  };

  const onProductoFinancieroChange = async(e) => {
    var producto = productosFinancieros.find(producto => producto.idprodfinanciero === e.target.value);
    setCamposInventario(JSON.parse(producto.fields));
    setFinancialProductSelected(producto.idprodfinanciero);





    let url = `${process.env.REACT_APP_SERVER_URL}/api/productos/${localStorage.getItem('idcompany')}/${producto.id}?estado=disponible`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
      });
  
      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        return;
      }

      var data = await response.json();
      setProductos(data);
  
    } catch (error) {
      console.log(error)
      throw error;
    }
  }


  return (
    <>
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Cobrar Inicial</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mb={2}>
            {!financialProductSelected ? (
            <Grid item size={12}>
              <Paper 
                sx={{ 
                  borderRadius: 3, 
                  boxShadow: "none", 
                  minHeight: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fafafa",
                  border: "2px dashed #e0e0e0",
                  p: 4
                }}
              >
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <Stack spacing={3} alignItems="center">
                    {/* Icon Container */}
                    <Box
                      sx={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        backgroundColor: "#e3f2fd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2
                      }}
                    >
                      <AccountBalanceIcon 
                        sx={{ 
                          fontSize: 60, 
                          color: "#1976d2",
                          opacity: 0.7
                        }} 
                      />
                    </Box>

                    {/* Main Message */}
                    <Typography 
                      variant="h5" 
                      fontWeight={700} 
                      color="text.primary"
                      sx={{ mb: 1 }}
                    >
                      Selecciona un Producto Financiero
                    </Typography>

                    {/* Subtitle */}
                    <Typography 
                      variant="body1" 
                      color="text.secondary"
                      sx={{ maxWidth: 500, lineHeight: 1.6 }}
                    >
                      Para comenzar a cobrar un inicial, primero debes seleccionar el tipo de producto financiero que deseas procesar.
                    </Typography>

                    {/* Product Selector */}
                    <Box sx={{ mt: 3, width: "100%", maxWidth: 400 }}>
                      <Selector
                        sx={{ width: "100%" }}
                        value={financialProductSelected}
                        onChange={(e) => onProductoFinancieroChange(e)}
                        options={productosFinancieros.map(producto => ({
                          label: JSON.parse(producto.generales).nombre,
                          value: producto.idprodfinanciero
                        }))}
                        placeholder="Selecciona un producto financiero"
                      />
                    </Box>
                    

                    {/* Additional Info */}
                    <Box
                      sx={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: 2,
                        p: 3,
                        mt: 2,
                        border: "1px solid #e0e0e0",
                        width: "100%",
                        maxWidth: 500
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                        <InfoIcon sx={{ color: "#666", fontSize: 20 }} />
                        <Typography variant="body2" color="text.secondary" textAlign="center">
                          Los productos financieros disponibles incluyen préstamos, créditos y otros servicios financieros
                        </Typography>
                      </Stack>
                    </Box>

                  </Stack>
                </Box>
              </Paper>
            </Grid>
            ):(
            <>  
             <Grid item size={12}>
                <Selector
                    sx={{width:400, marginTop:2, backgroundColor:"white"}}
                    value={financialProductSelected}
                    onChange={(e) => onProductoFinancieroChange(e)}
                    options={productosFinancieros.map(producto => ({label:JSON.parse(producto.generales).nombre,value:producto.idprodfinanciero}))}
                    placeholder="Tipo de producto"/>
             </Grid>
             <Grid item size={12} mt={2}>
                <Typography fontWeight={600} variant="h6">Datos del cliente</Typography>
             </Grid>
             <Grid item size={12}>
                <Autocomplete
                    options={clientes}
                    getOptionLabel={(option) => option.identificacion || ""}
                    renderInput={(params) => <TextField {...params} placeholder="Clientes" fullWidth />}
                    onChange={(e, val) => handleClienteChange(val)}
                    onInputChange={(e, newInputValue, reason) => {handleClienteInputChange(e, newInputValue,reason)}}
                    inputValue={formatIdentification(clienteInputValue)}
                    value={clienteSelected}
                />
             </Grid>
             <Grid item size={12}>
                <TextField
                    fullWidth
                    placeholder="Nombre del cliente"
                    value={nombreCliente}
                    onChange={(e) => setNombreCliente(e.target.value)}
                    disabled={clienteSelected?true:false}
                />
             </Grid>
             </>
            )}
            {(financialProductSelected && clienteSelected || financialProductSelected && nombreCliente!="")  && (
                
                <Grid container spacing={2} mb={2} mt={2}>
                    <Grid item size={12}>
                        <Typography variant="h6" fontWeight={700} textAlign={"left"}>{capitalize(camposInventario[0].alias + " para financiamiento")}</Typography>
                    </Grid>
                    <Grid item size={12}>
                        <Autocomplete
                            options={productos}
                            getOptionLabel={(option) => option.id}    
                            renderInput={(params) => <TextField {...params} placeholder="Productos" fullWidth/>}
                            onChange={(e, val) => {setProductoSelected(val)}}
                            fullWidth
                        />
                    </Grid>
    
                {productoSelected && camposInventario.map((campo,index) => {
                    var value = JSON.parse(productoSelected["campos"])[campo.id];

                    return(
                    <>
                    <Grid item size={4} key={campo.id}>
                    <Typography fontWeight={600} textAlign={"left"} mx={1}>{campo.id=="id"?capitalize(campo.alias):capitalize(campo.name)}</Typography>
                    <TextField
                    slotProps={{
                        input: {
                        startAdornment:campo.type === 'monto' ? (
                            <InputAdornment position="start">{moneda.label}$</InputAdornment>
                        ) : null,
                        },
                    }}
                        fullWidth
                        value={campo.type=="monto"?formatNumberWithCommas(value?.toString()): value}
                        disabled={true}
                        />
                    </Grid>
                        
                        </>)
                    })}
                    </Grid>
                )
            }

        </Grid>
        {(financialProductSelected && productoSelected) && (
            <>
            <Typography variant="body2" mb={2}>
            Ingrese el monto del inicial que desea cobrar:
            </Typography>
            <TextField
            fullWidth
            placeholder="Monto del inicial"
            value={formatNumberWithCommas(monto)}
            onChange={(e) => {setMonto(e.target.value.replace(/[^0-9.]/g, ''));}}
            InputProps={{
                startAdornment: <InputAdornment position="start">RD$</InputAdornment>,
            }}/>
            <TextField
            fullWidth
            placeholder="Descripción"
            value={descripcion}
            onChange={(e) => {setDescripcion(e.target.value)}}
            />
            </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{onClose()}} color="inherit">
          Cancelar
        </Button>
        <Button
          sx={{ fontWeight: "bold" }}
          onClick={handleConfirm}
          color="primarybutton"
          variant="contained"
          disabled={!monto || parseFloat(monto) <= 0}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>

    {/* Payment Method Dialog */}
    <MetodoDePagoDialog
      open={showPaymentDialog}
      onClose={handlePaymentDialogClose}
      onConfirm={handlePaymentConfirm}
      amount={parseFloat(monto) || 0}
      title="Método de Pago - Cobro Inicial"
      description="Seleccione el método de pago para procesar el cobro inicial"
      showAmount={true}
      allowMultiple={true}
      defaultMethod="efectivo"
    />

    {/* Alert Message Dialog */}
    <AlertMessageDialog 
      message={alertMessage} 
      title={''} 
      severity={alertSeverity} 
      color={alertSeverity} 
      open={openAlert} 
      handleClose={()=>{setOpenAlert(false)}}
    />
    </>
  );
};

export default CobrarInicialMainDialog;
